import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {TranslateContext} from "../../../context/TranslateContext";
import {aggiornaNotificaApi, getNotificheApi} from "../services/HomeServices";
import DashboardNotificheView from "./DashboardNotificheView";
import {AuthContext} from "../../../context/AuthContext";

export default function DashboardNotificheController() {

    const [loadingData, setLoadingData] = useState(true);
    const [notifiche, setNotifiche] = useState([]);

    const {annoKpi} = useContext(AuthContext);
    const {translate} = useContext(TranslateContext);
    const history = useHistory();

    async function getNotifiche() {
        const response = await getNotificheApi();
        setNotifiche(response.data.data);
        setLoadingData(false);
    }

    useEffect(() => {
        if (annoKpi) {
            getNotifiche();
        }
    }, [annoKpi]);

    async function aggiornaNotifica(n) {
        const response = await aggiornaNotificaApi(n.id_notifica);
        setNotifiche(response.data.data);
        setLoadingData(false);
    }

    return (
        /* Disegno solo se sono presenti dati */
        !loadingData && notifiche &&
        <DashboardNotificheView
            translate={translate}
            notifiche={notifiche}
            history={history}
            aggiornaNotifica={aggiornaNotifica}
        />
    );
}